var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.usersItems,"outlined":_vm.outlined,"chips":"","label":_vm.label,"multiple":""},model:{value:(_vm.localUsers),callback:function ($$v) {_vm.localUsers=$$v},expression:"localUsers"}})}
var staticRenderFns = []

export { render, staticRenderFns }